import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { InvoiceDeleteActionsRenderer } from '../../../shared/ag-grid/cell-renderers/invoice-delete.componet'; 
import { SupplementaryInvoiceService } from 'src/app/services/misc/supplementary/supplementary.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SupplementaryInvoiceUpdateDuesComponent } from '../updatedues/updatedues.component';
import * as printJS from 'print-js';
import { IRNStatusRenderer } from '../../../shared/ag-grid/cell-renderers/IRNStatusRenderer'; 
import { IRNAdditonalDetailsComponent } from '../irnadditonaldetails/irnadditonaldetails.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class SupplementaryInvoiceListComponent implements OnInit {
  manifestList = [];
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isActionAllowed = true;
  public isCollapsed = true;
  isDisabled = true;
  isCheckboxDisabled = true;
  filteredRows!: any[];
  checkboxRows!: any[];
  areSelected = true;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    flex: 1,
    sortable: true,
    resizable: true,
    filter: true
  };

  gridOptions: GridOptions;
  columnDefs = [
    {
      headerName: 'Invoice No.', field: 'invoicenofull', filter: true,
      checkboxSelection: (params) => !params.data.issuccess, headerCheckboxSelection: true,
      sortable: false, flex: 1, pinned: 'left', minWidth: 180
    },
    { headerName: 'Invoice Date', field: 'invoicedate', minWidth: 120 },
    { headerName: 'AWB Number', field: 'awbnumber', minWidth: 140 },
    { headerName: 'Bill To', field: 'billto', minWidth: 90 },
    { headerName: 'Bill Type', field: 'billtype', minWidth: 100 },
    { headerName: 'Company', field: 'company', minWidth: 240 },
    { headerName: 'Service Center', field: 'servicecenter', minWidth: 240 },
    {
      headerName: 'Status',
      field: 'invoicenofull',
      cellRenderer: IRNStatusRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 90,
      pinned: 'right'
    },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: InvoiceDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 120,
      pinned: 'right'
    },
  ];

  selectedSCId = null;
  rowData = [];
  cellId: number;
  constructor(
    public router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private invoiceService: SupplementaryInvoiceService,
    public modalService: NgbModal,
    private titleService: Title
  ) {
    titleService.setTitle('Supplementary');
    this.context = {
      componentParent: this,
      componentName: 'SupplementaryInvoiceListComponent',
      actionConfig: { delete: true, edit: false, view: true, print: true, updateDue: true }
    };

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 20,
      domLayout: 'autoHeight',
      rowSelection: 'multiple',
      frameworkComponents: {
        IRNStatusRenderer: IRNStatusRenderer
      }
    } as any
  }

  ngOnInit(): void {
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe((val) => {
        this.selectedSCId = val;
        this.getAllInvoiceList();
      });
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Supplementary');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  async printPdfAction(cell: any) {
    let printData: any = {};
    printData.invoiceType = 'Sales';
    printData.invoiceNo = cell?.invoicenofull;
    // console.log("printData", printData);
    try {
      this.ngxLoaderService.start();
      this.invoiceService.printPDF(printData).subscribe(res => {
        if (res && res.success) {
          // console.log("pdf generated for :-", res);
          let pdfString = JSON.parse(res.data);
          printJS({ printable: pdfString, type: 'pdf', base64: true, showModal: true });
          this.ngxLoaderService.stop();
        }
      });
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  async getAllInvoiceList(refresh = false) {
    this.ngxLoaderService.start();
    try {
      this.invoiceService.GetAllList({ id: this.selectedSCId,refresh: refresh }).subscribe((res: any) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.rowData = res.data;
          // console.log("Fetched rowData:__", this.rowData);
        } else {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  ngOnDestroy(): void { }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    params.api.sizeColumnsToFit();
  }

  errorAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.errAlert('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.invoicenofull) {
        const invoiceData = this.rowData.find(item => item.invoicenofull === cell.invoicenofull);
        if (invoiceData) {
          this.openErrorModel(cell.invoicenofull, invoiceData.additionaldetails)
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  openErrorModel(invoicenofull: string, cell: any) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    const modalRef = this.modalService.open(IRNAdditonalDetailsComponent, ngbModalOptions);
    modalRef.componentInstance.invoiceNo = invoicenofull;
    modalRef.componentInstance.cellData = cell;
  }

  UpdateAmount(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.errAlert('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.invoiceService.GetDuesById(cell.id).subscribe(res => {
          if (res && res.success) {
            this.openUpdateDueModel(res.data.length ? res.data[0] : null);
          }
        })
      }
    } catch (e) {
      console.error(e);
    }
  }

  openUpdateDueModel(cell: any) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    const modalRef = this.modalService.open(SupplementaryInvoiceUpdateDuesComponent, ngbModalOptions);
    modalRef.componentInstance.cellData = cell;
    modalRef.result.then(
      (obj) => {
        if (obj) {
          try {
            this.ngxLoaderService.start()
            this.invoiceService.updateDues(obj).subscribe(res => {
              if (res && res.success) {
                this.ngxLoaderService.stop()
                this.appCoreService.showMessage('Record saved Successfully.', 'Success', 'success')
              }
            })
          } catch (error) {
            this.ngxLoaderService.stop()
          }
          this.getAllInvoiceList();
        }
      },
      (reason) => {
      }
    );
  }

  viewAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.openErrorDialog('No Access to View.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate(['/invoices/supplementary/view', cell.id]);
      }
    } catch (e) {
      console.error(e);
    }
  }


  async deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.errAlert('No Access to Delete.');

    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      const result = await this.openConfirmationDialog('Are you sure ?', 'You want to delete.', cell.id);
      result ? this.deleteRecord(cell.id) : null;
    }
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.invoiceService.DeleteById(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.getAllInvoiceList(true);
            this.appCoreService.showMessage('Record deleted successfuly','Success','success');
          }
        });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  async openConfirmationDialog(msg1: any, msg2?: any, id?: number): Promise<boolean> {
    const result = await Swal.fire({
      // titleText: 'Confirmation',
      html: msg2 ? `<span>${msg1}</span><br><span>${msg2}</span>` : `<span>${msg1}</span>`,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    } else return false;

  }

  errAlert(msg: any) {
    Swal.fire({
      icon: 'warning',
      title: 'Oops...',
      text: msg,
    });
  }

  formateDate(datetime: any): string {
    try {
      const timestamp = new Date(datetime);
      const year = timestamp.getFullYear();
      const month = (timestamp.getMonth() + 1).toString().padStart(2, '0');
      const day = timestamp.getDate().toString().padStart(2, '0');
      return `${day}-${month}-${year}`;
    } catch (e) {
      console.error('Error occurred during date parsing:', e);
      return '';
    }
  }

  onRowSelected(event) {
    let req = this.gridOptions.api.getSelectedRows();
    if (req.length > 0) {
      this.areSelected = false;
    }
    else {
      this.areSelected = true;
    }
  }

  async openErrorDialog(msg: any) {
    Swal.fire({
      title: 'Ooops!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  generateIRN() {
    let req = this.gridOptions.api.getSelectedRows();
    let filteredInvoiceNo = req.map(x => x.invoicenofull);
    if (filteredInvoiceNo.length > 0) {
      try {
        for (var i = 0; i < filteredInvoiceNo.length; i++) {
          let reqObj = { invoiceno: filteredInvoiceNo[i] };
          this.ngxLoaderService.start();
          this.invoiceService.IRNGenerate(reqObj).subscribe((res) => {
            if (res && res.success) {
              // console.log("genrate IRN response : ", res);
            }
          })
        }
        this.ngxLoaderService.stop();
      } catch (err) {
        console.log(err);
        this.ngxLoaderService.stop();
      }
    }
  }

  async cancelIRN(event: any) {
    if (event.id) {
      const confirmed = await this.openConfirmationDialog('<span>Are you sure you want to <b>cancel</b> this IRN ?</span>');
      if (confirmed) {
        try {
          this.ngxLoaderService.start();
          this.invoiceService.cancelIRN({ id: event.id }).subscribe((res) => {
            if (res && res.success) {
              // console.log("genrate IRN response : ", res);
            }
          })
          this.ngxLoaderService.stop();
        } catch (err) {
          console.log(err);
          this.ngxLoaderService.stop();
        }
      }
    }
  }
}
